type WriterUrlInput = {
  pathname: string;
};

/**
 * TechDocs can render from /docs/... or /catalog/.../docs depending on entry point,
 * so we normalize to a /docs/... path for writer URLs.
 * Examples:
 * /docs/default/component/plugin-development-golden-path -> unchanged
 * /catalog/default/component/plugin-development-golden-path/docs -> /docs/default/component/plugin-development-golden-path
 */
const getDocsPathname = (pathname: string) => {
  if (pathname.startsWith('/docs/')) return pathname;
  if (!pathname.startsWith('/catalog/')) return '';

  const parts = pathname.replace(/^\/catalog\//, '').split('/');
  if (parts.length < 4) return '';

  const [namespace, kind, name, docsSegment, ...rest] = parts;
  if (docsSegment !== 'docs') return '';

  const suffix = rest.length > 0 ? `/${rest.join('/')}` : '';
  return `/docs/${namespace}/${kind}/${name}${suffix}`;
};

const buildWriterUrl = ({ pathname }: WriterUrlInput) => {
  const docsPathname = getDocsPathname(pathname);
  if (!docsPathname) return '';
  return `/techdoc-editor${docsPathname}`;
};

export { buildWriterUrl, getDocsPathname, type WriterUrlInput };
